import { render, staticRenderFns } from "./PersonnelEdit.vue?vue&type=template&id=01a144f5&scoped=true&"
import script from "./PersonnelEdit.vue?vue&type=script&lang=js&"
export * from "./PersonnelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a144f5",
  null
  
)

export default component.exports